var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAllTools = function SvgAllTools(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.32 10.68c0-.47.39-.86.86-.86h5c.43 0 .82.39.82.86v5c0 .43-.39.82-.82.82h-5c-.47 0-.86-.39-.86-.82zM.82 16.5c-.43 0-.82-.39-.82-.82v-5c0-.47.39-.86.82-.86h5c.47 0 .86.39.86.86v5c0 .43-.39.82-.86.82zM0 2.32c0-.43.39-.82.82-.82h5c.47 0 .86.39.86.82v5c0 .47-.39.86-.86.86h-5c-.43 0-.82-.39-.82-.86zM10.781.992a.9.9 0 0 1 1.211 0l3.516 3.555c.312.312.312.82 0 1.172l-3.555 3.515c-.312.352-.82.352-1.172 0L7.266 5.72c-.352-.352-.352-.86 0-1.172z"
  })));
};
export default SvgAllTools;